import { useLanguage } from "@/context/LanguageContext";
import {
  content,
  APP_OGGI,
  APP_DIARIO,
  APP_PIANO_LISTA,
  APP_CATALOG,
  APP_RECIPE_RICOTTA,
  FOOD_POLPETTE,
  FOOD_PESCE,
  FOOD_FEGATO,
  FOOD_BACCALA,
  FOOD_PASTA,
} from "@/content/fitswag";
import { PhoneFrame } from "@/components/PhoneFrame";
import Reveal from "@/components/Reveal";

const FOOD = [FOOD_POLPETTE, FOOD_PESCE, FOOD_FEGATO, FOOD_BACCALA, FOOD_PASTA];

export default function Gallery() {
  const { lang } = useLanguage();
  const t = content[lang].gallery;
  const shots = [APP_OGGI, APP_DIARIO, APP_PIANO_LISTA, APP_CATALOG, APP_RECIPE_RICOTTA];

  return (
    <section
      id="screenshots"
      className="relative overflow-hidden border-t border-white/10 bg-black py-24 md:py-32"
    >
      <div className="relative mx-auto max-w-7xl px-5 md:px-8">
        <Reveal className="max-w-2xl">
          <p className="overline text-brand-orange">{t.overline}</p>
          <h2 className="mt-3 font-display text-4xl leading-tight tracking-tighter text-white sm:text-5xl md:text-6xl">
            {t.title}
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-white/60">{t.subtitle}</p>
        </Reveal>

        <div className="mt-14 grid grid-cols-2 gap-6 sm:grid-cols-3 lg:grid-cols-5">
          {shots.map((s, i) => (
            <Reveal key={i} delay={i * 0.06}>
              <figure data-testid={`gallery-shot-${i}`}>
                <PhoneFrame src={s} alt={t.captions[i]} size="sm" className={i === 2 ? "lg:-translate-y-4" : ""} />
                <figcaption className="overline mt-4 text-center text-white/50">
                  {t.captions[i]}
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>

      {/* cinematic food strip */}
      <div className="relative mt-20 overflow-hidden">
        <div className="flex w-max animate-marquee gap-4">
          {[...FOOD, ...FOOD].map((src, i) => (
            <div
              key={i}
              className="h-44 w-72 shrink-0 overflow-hidden rounded-2xl border border-white/10 sm:h-56 sm:w-96"
            >
              <img src={src} alt="" loading="lazy" className="h-full w-full object-cover" />
            </div>
          ))}
        </div>
        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-black to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-black to-transparent" />
      </div>
    </section>
  );
}
